import moment from 'moment';

export default function filterByWeekAndMonth(event, type, selectedDate, week) {
  const startDate = moment(event.START_DATE);
  const endDate = moment(event.END_DATE);

  const rangeStart = type === 'month' ? selectedDate.clone().startOf('month') : getWeek(selectedDate, week).startOf('week');
  const rangeEnd = type === 'month' ? selectedDate.clone().endOf('month') : getWeek(selectedDate, week).endOf('week');

  if (startDate.isSameOrAfter(rangeStart) && endDate.isSameOrBefore(rangeEnd)) {
    return true;
  }

  if (startDate.isSameOrBefore(rangeStart) && (endDate.isSameOrAfter(rangeStart) && endDate.isSameOrBefore(rangeEnd))) {
    return true;
  }

  if ((startDate.isSameOrAfter(rangeStart) && startDate.isSameOrBefore(rangeEnd)) && (endDate.isSameOrAfter(rangeEnd))) {
    return true;
  }

  if (startDate.isSameOrBefore(rangeStart) && endDate.isSameOrAfter(rangeEnd)) {
    return true;
  }

  return false;
}

export function filterByWeek(event, selectedDate, week) {
  return filterByWeekAndMonth(event, 'week', selectedDate, week);
}

export function filterByMonth(event, selectedDate) {
  return filterByWeekAndMonth(event, 'month', selectedDate);
}

function getWeek(selectedDate, week) {
  return selectedDate.clone().week(week);
}



// WEBPACK FOOTER //
// ./src/services/filters/filterByWeekAndMonth.js